import { Skeleton } from '@/components/ui/skeleton';
import { SkeletonGrid } from '../skeletons';

export function UnsplashGridSkeleton() {
  return (
    <SkeletonGrid
      prefix="unsplash-img"
      count={10}
      className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5"
    >
      {(key) => <Skeleton key={key} className="aspect-square w-full rounded-md" />}
    </SkeletonGrid>
  );
}
